import { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import styles from './EventSpecificStatusPage.module.css'

// ------ Services ------ //
import * as clientEventService from '../../../services/clientEventService'

// Pages
import EventSetupStatusManager from '../../../pages/Home/StatusSubpages/EventSetupStatusManager'
import EventBadgesStatusManager from '../../../pages/Home/StatusSubpages/EventBadgesStatusManager'
import GuestBadgesStatusManager from '../../../pages/Home/StatusSubpages/GuestBadgesStatusManager'
import ExtraBadgesStatusManager from '../../../pages/Home/StatusSubpages/ExtraBadgesStatusManager'
import KioskSetupStatusManager from '../../../pages/Home/StatusSubpages/KioskSetupStatusManager'

// Components
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'

const EventSpecificStatusPage = () => {
    const location = useLocation()
    const passedState = location.state

    const resolveClientEvent = () => {
        if (passedState && passedState.clientName) {
            return {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
        }
        return clientEventService.getClientEvent() || {}
    }

    const [clientEventInfo, setClientEventInfo] = useState({})
    const [tabIndex, setTabIndex] = useState(0)
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }

    }
    useEffect(() => {
        setClientEventInfo(resolveClientEvent())
    }, [])

    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }

    }, [])

    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])

    const tabLabels = [
        "Event Setup",
        "Event Badges Setup",
        "Guest Badges Setup",
        "Extra Badges Setup",
        "Kiosk Setup"
    ]

    if (!clientEventInfo || !clientEventInfo.clientId) {
        return <LoadingSpinner />
    }

    return (
        <div id={styles.ESSPage}>
            <div>
                <div className={styles.headingArea}>
                    <h1>{clientEventInfo.eventName} - Status Manager</h1>
                    {/*<HoverButton*/}
                    {/*    title={'NOTE: Page loads a lot of information! Any client/event selection changes will take time to render!'}*/}
                    {/*    messageWidth={150}*/}
                    {/*/>*/}
                </div>
                <Tabs
                    selectedIndex={tabIndex}
                    onSelect={(index) => setTabIndex(index)}
                    id={styles.tabsSection}
                >
                    <TabList id={styles.tabsList}>
                        {tabLabels.map((label, index) => (
                            <Tab key={index} className={index === tabIndex ? styles.selected : styles.tabs}>
                                {label}
                            </Tab>
                        ))}
                    </TabList>

                    <TabPanel>
                        <EventSetupStatusManager/>
                    </TabPanel>
                    <TabPanel>
                        <EventBadgesStatusManager />
                    </TabPanel>
                    <TabPanel>
                        <GuestBadgesStatusManager />
                    </TabPanel>
                    <TabPanel>
                        <ExtraBadgesStatusManager />
                    </TabPanel>
                    <TabPanel>
                        <KioskSetupStatusManager />
                    </TabPanel>
                </Tabs>
            </div>
        </div>
    );
}

export default EventSpecificStatusPage;